import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../css/slickCarousel.css";
import GView from "../gComponents/GView";
import GText from "../gComponents/gText";
import { ImgUrl, addDefaultSrc } from "../services";
import { ReactComponent as Check } from "../assets/images/tick.svg";
import styled from "styled-components";

const IconDiv = styled.div`
  position: relative;
  svg {
    width: 20px;
    height: 20px;
    background: #fff;
    position: absolute;
    right: 10px;
    border: 2px solid #fff;
    border-radius: 20px;
    path {
      fill: ${({ theme }) => theme.body};
    }
  }
`;

const OrderVehicles = (props) => {
  const [vehicleTypes, setVehicleTypes] = useState(props.data);
  const [selectedVehicle, setSelectedVehicle] = useState(props.selectedVehicleType || "");

  var SliderSettings = {
    dots: false,
    infinite: false,
    swipe: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
  };

  return (
    <GView style={{ padding: "5px 0" }}>
      <GText g4 semi text={"Choose Vehicle"} style={{ marginBottom: "20px" }} />
      <Slider {...SliderSettings}>
        {vehicleTypes.map((v, i) => {
          return (
            <GView
              key={i}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedVehicle(v.id);
                if (props.onSelect) {
                  props.onSelect(v.id);
                }
              }}
              style={{outline:0,boxShadow:"none"}}
            >
              {v.id == selectedVehicle && (
                <IconDiv>
                  <Check style={{fill:"#0381fe"}}/>
                </IconDiv>
              )}
              <img
                src={ImgUrl("vehicle_type") + "/" + v.thumb_photo}
                alt={v.title}
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  margin: "0 auto",
                  cursor: "pointer",
                }}
                onError={(e) => addDefaultSrc(e, "vehicle")}
              />
              <GText
                text={v.title}
                style={{
                  textAlign: "center",
                  padding: "5px 0",
                  cursor: "pointer",
                }}
              ></GText>
            </GView>
          );
        })}
      </Slider>
    </GView>
  );
};

export default OrderVehicles;
